
import {NgModule} from '@angular/core';
import {EntityDataService, EntityServices} from '@ngrx/data';
import {errorMessages} from '../../../core/error/errorMessages';
import {PartnerPersonRepository} from './impl/service/ngrx/partnerPerson.repository';
import {PartnerPersonService} from './impl/service/ngrx/partnerPerson.service';

@NgModule()
export class PartnerPersonModule {
    constructor(entityDataService: EntityDataService,
                entityServices: EntityServices,
                partnerPersonDataService: PartnerPersonService,
                partnerPersonService: PartnerPersonRepository,
    ) {

        entityDataService.registerServices({
            PartnerPerson: partnerPersonDataService,
        });

        entityServices.registerEntityCollectionServices({
            PartnerPerson: partnerPersonService,
        });

        errorMessages.set('PARTNER_PERSON_SAVE_UNIQUE_TYPE_ALREADY_EXISTS', 'Une personne avec ce type existe déjà');
        errorMessages.set('PARTNER_PERSON_DELETE_PATIENT_CANNOT_BE_DELETED', 'La personne "patient" n\' est pas supprimable');

    }
}
